"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CadMap = void 0;
var PIXI = window.PIXI;
const dwgservice_1 = __importDefault(require("../dwgservice"));
const ltdwgserver_1 = require("../cad/ltdwgserver");
const ltcanvas_1 = require("../cad/ltcanvas");
const commandfactory_1 = require("./commandfactory");
const pancommands_1 = require("../tools/pancommands");
const selectcommands_1 = require("../tools/selectcommands");
const easyeditcommands_1 = require("../tools/easyeditcommands");
const snap_1 = require("./snap");
const ltpoint_1 = require("../cad/ltpoint");
const registerCommand_1 = require("./registerCommand");
const ltutils_1 = require("../cad/ltutils");
const undostack_1 = require("./undostack");
const ltfeature_1 = require("../data/ltfeature");
const ltvectorlayer_1 = require("../data/ltvectorlayer");
const lodash_1 = require("lodash");
const ltrendermode_1 = require("../ltrendermode");
const sprinklerutils_1 = require("../../business/sprinkler/sprinklerutils");
const resourceList = ["fonts/正等线体.fnt"];
class CadMap {
    //初始化函数;
    constructor(options) {
        this._canvas = null;
        this._max_id = 0;
        this._active_layer = null;
        this._moving_mappos = null;
        this._cursor_type = ltutils_1.MapCursorType.CursorDefault;
        this._show_message = true;
        this._cursor_color = 0xffffff;
        //
        this.canvs_width = 0;
        this.canvs_height = 0;
        this._command_message = [];
        var canvas = options.canvas;
        ltrendermode_1.CadSetting.Instance.useOnlyRender = options.rendermode || false;
        this._show_message = options.show_message || true;
        this._reators = new Set();
        this._dwg_server = new ltdwgserver_1.LTDwgServer(this);
        this._canvas_container = canvas;
        // 创建一个pixi渲染器
        this.canvs_width = canvas.clientWidth;
        this.canvs_height = canvas.clientHeight;
        this.app = new PIXI.Application({
            width: this.canvs_width,
            height: this.canvs_height,
            transparent: 0x000,
            resolution: 1,
            //backgroundColor: 0x1099bb,
            antialias: true
        });
        this.app.stage.interactive = true;
        this.app.stage.buttonMode = true;
        this.app.stage.hitArea = this.app.screen;
        //修改背景颜色;
        // this.app.renderer.backgroundColor=0xFF0000;
        window.cadmap = this;
        canvas.appendChild(this.app.view);
        //添加root；
        this._container = new PIXI.Container();
        this.app.stage.addChild(this._container);
        this._container.x = 0;
        this._container.y = 0;
        this._container.width = this.app.screen.width;
        this._container.height = this.app.screen.height;
        var mat = new PIXI.Matrix();
        mat.translate(0, -this.app.screen.height);
        mat.scale(1, -1);
        this._container.transform.setFromMatrix(mat);
        this._undo_stack = new undostack_1.UndoStack(this);
        //this.app.stop();
        this._select_graphics = ltrendermode_1.CadSetting._newGraphics();
        this._container.addChild(this._select_graphics);
        let glow_filter = new window.PIXI.GlowFilter();
        this._select_graphics.filters = [glow_filter];
        this._select_graphics.zIndex = 1000;
        this._track_graphics = ltrendermode_1.CadSetting._newGraphics();
        this._container.addChild(this._track_graphics);
        this._track_graphics.zIndex = 1001;
        canvas.addEventListener("mousedown", (event) => this.onMouseDown(event));
        canvas.addEventListener("mousemove", (event) => this.onMouseMove(event));
        canvas.addEventListener("mouseup", (event) => this.onMouseUp(event));
        canvas.addEventListener("wheel", (event) => this.onWheel(event));
        canvas.addEventListener("keydown", (event) => this.onKeyDown(event));
        canvas.addEventListener("mouseleave", (event) => this.onMouseLeave(event));
        window.onresize = () => {
            return (() => {
                this.resize(this._canvas_container.clientWidth, this._canvas_container.clientHeight);
            })();
        };
        //初始命令注册;
        registerCommand_1.RegisterCommand.init();
        this.pan_command = new pancommands_1.PanCommand(this);
        this.select_command = new selectcommands_1.SelectCommand(this);
        this.select_command.continueSelect = true;
        this.easyedit_command = new easyeditcommands_1.EasyEditCommand(this);
        this._snap = new snap_1.SnapAuto();
        this._layers = [];
        this._initCanvas();
        this.initEdit();
    }
    resize(width, height) {
        if (this.app && this.app.renderer) {
            this.app.renderer.resize(width, height);
        }
    }
    initEdit() {
        //添加编辑框;
        this._distance_input = new window.PIXI.TextInput({
            input: {
                fontFamily: 'Arial',
                fontSize: '15px',
                padding: '1px',
                width: '80px',
                color: '#26272E',
            },
            box: {
                default: { fill: 0xE8E9F3, rounded: 2, stroke: { color: 0xCBCEE0, width: 3 } },
                focused: { fill: 0xE1E3EE, rounded: 2, stroke: { color: 0xABAFC6, width: 3 } },
                disabled: { fill: 0xDBDBDB, rounded: 2 }
            }
        });
        this._distance_input.x = 300;
        this._distance_input.y = 100;
        this._distance_input.pivot.x = this._distance_input.width / 2;
        this._distance_input.pivot.y = this._distance_input.height / 2;
        this._distance_input.visible = false;
        this.app.stage.addChild(this._distance_input);
        this._distance_input.on('keydown', (keyCode) => {
            if (keyCode == 13) //enter
             {
                if (commandfactory_1.CommandFactory.getInstance().currentCommand) {
                    this._distance_input.visible = false;
                    commandfactory_1.CommandFactory.getInstance().putString(this, this._distance_input.text);
                    this.focus();
                }
                else {
                    this._distance_input.visible = false;
                    let command = commandfactory_1.CommandFactory.getInstance().getCommand(this._distance_input.text);
                    if (command === undefined || command === null) {
                        this.printMessage(`未知命令:${this._distance_input.text}`);
                        return;
                    }
                    commandfactory_1.CommandFactory.getInstance().execCommand(command._command_name, this);
                }
            }
        });
    }
    setDistanceEditValue(x, y, length) {
        this._distance_input.x = x;
        this._distance_input.y = y - 20;
        this._distance_input.text = length.toFixed(3);
        this._distance_input.visible = true;
        //获取长度,计算不对，暂时先这样
        let width = this._distance_input.text.length * 10;
        width += 10;
        this._distance_input.width = width;
        this._distance_input._dom_input.select();
    }
    focus() {
        this._canvas_container.focus();
    }
    set maxID(id) {
        this._max_id = id;
    }
    get maxID() {
        return this._max_id;
    }
    get canvas() {
        return this._canvas || {};
    }
    //获取捕捉对象
    get snap() {
        return this._snap;
    }
    get pixiApp() {
        return this.app;
    }
    get mapContainer() {
        return this._container;
    }
    get screenContainer() {
        return this.app.stage;
    }
    get selectGraphics() {
        return this._select_graphics;
    }
    get trackGraphics() {
        return this._track_graphics;
    }
    set backgroundColor(color) {
        this.app.renderer.backgroundColor = color;
        for (let layer of this._layers) {
            let graphics_datas = layer.layerGraphics.geometry.graphicsData;
            for (let sub_data of graphics_datas) {
                let wipe_out = sub_data.wipeout || false;
                if (wipe_out)
                    sub_data.fillStyle.color = color;
            }
        }
        this.invalidate();
        //重设光标;
        if (this._mouse_graphic != null) {
            this._mouse_graphic.cursor_type = -1;
        }
    }
    get backgroundColor() {
        return this.app.renderer.backgroundColor;
    }
    //移动地图;
    move(x, y) {
        var container_mat = this._container.transform.worldTransform;
        var m4 = container_mat.translate(x, y);
        this._container.transform.setFromMatrix(m4);
    }
    clearLayers() {
        this.reset();
        this._layers = [];
    }
    get cursorType() {
        return this._cursor_type;
    }
    set cursorType(type) {
        this._cursor_type = type;
    }
    get cursorColor() {
        return this._cursor_color;
    }
    set cursorColor(color) {
        this._cursor_color = color;
    }
    reset() {
        for (let sub_layer of this._layers) {
            sub_layer.clearGraphics();
        }
        this._snap.clear(this);
        this.easyedit_command.clear();
        this.easyedit_command.reset();
        this.select_command.reset();
        if (this._distance_input != undefined) {
            this._distance_input.visible = false;
        }
    }
    distanceEditHiden() {
        if (this._distance_input != undefined) {
            this._distance_input.visible = false;
        }
    }
    _initCanvas() {
        if (this._canvas != null) {
            return;
        }
        this._canvas = new ltcanvas_1.TsPixiCanvas(this, ltrendermode_1.CadSetting.Instance.useOnlyRender);
    }
    loadFinal() {
        window.loadMapEnd();
        console.log("全部图层 加载成功");
    }
    //鼠标按下实现;
    onMouseDown(event) {
        if (event.button == ltutils_1.ButtonStatus.LeftButton) {
            //隐藏菜单;
            window.onGbMouse();
        }
        if (this._distance_input != undefined) {
            this._distance_input.visible = false;
        }
        event.mapPos = this.toMapPoint(event.offsetX, event.offsetY);
        const button = window.event.button;
        if (!ltrendermode_1.CadSetting.Instance.useOnlyRender) {
            let current_command = commandfactory_1.CommandFactory.getInstance().currentCommand;
            if (current_command !== null) {
                if (button == ltutils_1.ButtonStatus.MiddleButton) {
                    this.pan_command.onMouseDown(event);
                    return;
                }
                var new_pos = this._snap.snap(event.mapPos, this);
                event.mapPos = new_pos;
                commandfactory_1.CommandFactory.getInstance().onMouseDown(this, event);
                return;
            }
            if (button == ltutils_1.ButtonStatus.MiddleButton) {
                this.pan_command.onMouseDown(event);
            }
            else {
                this.easyedit_command.onMouseDown(event);
            }
        }
        else {
            if (button == ltutils_1.ButtonStatus.MiddleButton) {
                this.pan_command.onMouseDown(event);
            }
        }
    }
    //获取地图当前的比例尺，代表一个像素中图上的距离;
    mapScale() {
        return this._container.transform.scale.x;
    }
    //获取正在移动的鼠标点;
    get movingPos() {
        return this._moving_mappos;
    }
    resetCursor() {
        let current_command = commandfactory_1.CommandFactory.getInstance().currentCommand;
        if (current_command !== null) {
            this.cursorType = ltutils_1.MapCursorType.CursorInCommand;
        }
        else {
            this.cursorType = ltutils_1.MapCursorType.CursorDefault;
        }
    }
    updateMouseCursor(event) {
        if (this._mouse_graphic == null) {
            this._mouse_graphic = ltrendermode_1.CadSetting._newGraphics();
            this.app.stage.addChild(this._mouse_graphic);
            this._mouse_graphic.cursor_type == -1;
        }
        if (this._mouse_graphic.cursor_type !== this._cursor_type) {
            this._mouse_graphic.clear();
            this._mouse_graphic.cursor_type = this._cursor_type;
            if (this._cursor_type == ltutils_1.MapCursorType.CursorInCommand) { //十字丝;
                this._mouse_graphic.lineStyle(1, this._cursor_color, 1);
                this._mouse_graphic.moveTo(0, -40);
                this._mouse_graphic.lineTo(0, 40);
                this._mouse_graphic.moveTo(-40, 0);
                this._mouse_graphic.lineTo(40, 0);
                this._mouse_graphic.endFill();
            }
            else if (this._cursor_type == ltutils_1.MapCursorType.CursorSingleSelect) {
                this._mouse_graphic.lineStyle(1, this._cursor_color, 1);
                let radius = 5;
                this._mouse_graphic.moveTo(-radius, -radius);
                this._mouse_graphic.lineTo(radius, -radius);
                this._mouse_graphic.lineTo(radius, radius);
                this._mouse_graphic.lineTo(-radius, radius); //绘制
                this._mouse_graphic.lineTo(-radius, -radius);
                this._mouse_graphic.endFill();
            }
            else if (this._cursor_type == ltutils_1.MapCursorType.CursorDefault) {
                this._mouse_graphic.lineStyle(1, this._cursor_color, 1);
                let radius = 5;
                this._mouse_graphic.moveTo(0, -40);
                this._mouse_graphic.lineTo(0, -radius);
                this._mouse_graphic.moveTo(0, radius);
                this._mouse_graphic.lineTo(0, 40);
                this._mouse_graphic.moveTo(-40, 0);
                this._mouse_graphic.lineTo(-radius, 0);
                this._mouse_graphic.moveTo(radius, 0);
                this._mouse_graphic.lineTo(40, 0);
                this._mouse_graphic.moveTo(-radius, -radius);
                this._mouse_graphic.lineTo(radius, -radius);
                this._mouse_graphic.lineTo(radius, radius);
                this._mouse_graphic.lineTo(-radius, radius); //绘制
                this._mouse_graphic.lineTo(-radius, -radius);
                this._mouse_graphic.endFill();
            }
        }
        this._mouse_graphic.x = event.offsetX;
        this._mouse_graphic.y = event.offsetY;
    }
    showContent() {
        let current_command = commandfactory_1.CommandFactory.getInstance().currentCommand;
        if (current_command !== null) {
            if (!(current_command instanceof commandfactory_1.AbstractCommand) && this.movingPos != null) {
                let offset_pos = this.toScreenPoint(this.movingPos.x, this.movingPos.y);
                window.showMouse(offset_pos.x, offset_pos.y, current_command.getButtonKeyList());
            }
        }
    }
    //鼠标移动;
    onMouseMove(event) {
        this.updateMouseCursor(event);
        if (event.button == ltutils_1.ButtonStatus.RightButton) {
            return;
        }
        event.mapPos = this.toMapPoint(event.offsetX, event.offsetY);
        if (!ltrendermode_1.CadSetting.Instance.useOnlyRender) {
            this._moving_mappos = event.mapPos;
            let current_command = commandfactory_1.CommandFactory.getInstance().currentCommand;
            if (current_command !== null) {
                let status = this.pan_command.onMouseMove(event);
                if (status == commandfactory_1.CommandStatus.eOK) {
                    return;
                }
                var new_pos = this._snap.snap(event.mapPos, this);
                event.mapPos = new_pos;
                commandfactory_1.CommandFactory.getInstance().onMouseMove(event);
                return;
            }
            this.pan_command.onMouseMove(event);
            if (this.selectedFeatures().length > 0) {
                if (this.easyedit_command.onMouseMove(event) == commandfactory_1.CommandStatus.eOK) {
                    return;
                }
            }
            this.select_command.onMouseMove(event);
        }
        else {
            this.pan_command.onMouseMove(event);
        }
    }
    //
    SaveJson(json, callback) {
        return this.dwgservice.dwgService.SaveJson(json, callback);
    }
    //鼠标抬起实现，接手命令相关工作;
    onMouseUp(event) {
        //判断是否有命令;
        const button = window.event.button;
        event.buttonstatus = button;
        event.mapPos = this.toMapPoint(event.offsetX, event.offsetY);
        if (!ltrendermode_1.CadSetting.Instance.useOnlyRender) {
            let current_command = commandfactory_1.CommandFactory.getInstance().currentCommand;
            if (current_command instanceof commandfactory_1.AbstractCommand) {
                if (button == ltutils_1.ButtonStatus.MiddleButton) {
                    this.pan_command.onMouseUp(event);
                    return;
                }
                var new_pos = this._snap.snap(event.mapPos, this);
                event.mapPos = new_pos;
                let res = current_command.onMouseUp(event);
                if (res == commandfactory_1.CommandStatus.eDone) {
                    this.finishCommand();
                    this.printMessage("*命令已结束*");
                }
                return;
            }
            if (button == ltutils_1.ButtonStatus.MiddleButton) {
                this.pan_command.onMouseUp(event);
            }
            else {
                if (this.easyedit_command.hasSelectNode(event.mapPos) == true) {
                    this.easyedit_command.onMouseUp(event);
                }
                this.select_command.onMouseUp(event);
            }
        }
        else {
            if (button == ltutils_1.ButtonStatus.MiddleButton) {
                this.pan_command.onMouseUp(event);
            }
        }
    }
    //滚轮实现;
    onWheel(event) {
        let current_pos = this.toMapPoint(event.offsetX, event.offsetY);
        if (event.deltaY < 0) {
            this.scaleMap(0.8, current_pos.x, current_pos.y);
        }
        else {
            this.scaleMap(1.25, current_pos.x, current_pos.y);
        }
    }
    // ESC键被按下
    escape() {
        this.finishCommand();
        this.printCommandTip("*命令已取消*");
    }
    startCommand() {
        if (this._time != undefined) {
            clearTimeout(this._time);
        }
    }
    finishCommand(current_command = null) {
        window.onGbMouse();
        this._snap.clear(this);
        this.easyedit_command.clear();
        this.easyedit_command.reset();
        let current_command_flag = commandfactory_1.CommandFlag.CommandSnap;
        if (current_command == null) {
            current_command_flag = commandfactory_1.CommandFactory.getInstance().currentCommandFlag;
        }
        else {
            current_command_flag = current_command._command_flag;
        }
        if (!(current_command_flag & commandfactory_1.CommandFlag.CommandSaveSelect)) {
            this.select_command.reset();
        }
        commandfactory_1.CommandFactory.getInstance()._reset(this);
        this.pan_command.reset();
        this.focus();
        //隐藏编辑框;
        this.distanceEditHiden();
        if (this._show_message == true) {
            //五秒钟完全消失;
            if (this._time != undefined) {
                clearTimeout(this._time);
            }
            if (this._command_alpha_filter !== undefined) {
                this._time = setInterval(() => {
                    if (this._command_alpha_filter.alpha > 0) {
                        this._command_alpha_filter.alpha -= 0.05;
                    }
                    else {
                        this._command_message = [];
                        this._command_message.push("");
                        this._command_message.push("");
                    }
                }, 250);
            }
        }
    }
    onMouseLeave(event) {
        if (this.pan_command != null) {
            this.pan_command.reset();
        }
    }
    onKeyDown(event) {
        if (event.key === "Escape" || event.key === "Esc") {
            this.escape();
            return;
        }
        // else if(event.key=="Tab" && this._distance_input.visible==true)
        // {
        //   this._distance_input.focus();
        //   return;
        // }
        //判断按下的是否为数字键;
        let command = commandfactory_1.CommandFactory.getInstance().currentCommand;
        if (!command) {
            if (this._distance_input.visible == false && (event.altKey == false && event.ctrlKey == false && event.shiftKey == false) && /^[0-9.a-zA-Z]$/.test(event.key)) {
                this._distance_input.visible = true;
                if (this._moving_mappos) {
                    let screen_pos = this.toScreenPoint(this._moving_mappos.x, this._moving_mappos.y);
                    this._distance_input.x = screen_pos.x;
                    this._distance_input.y = screen_pos.y - 20;
                }
                this._distance_input.select();
            }
            else {
                commandfactory_1.CommandFactory.getInstance().execKeyCommand(event, this);
            }
            return;
        }
        if (/^[0-9.]$/.test(event.key) && this._distance_input.visible == true) {
            this._distance_input.select();
            return;
        }
        else {
            commandfactory_1.CommandFactory.getInstance().execKeyCommand(event, this);
        }
    }
    addScreenGraphics(graphic) {
        this.app.stage.addChild(graphic);
    }
    addGraphics(graphic, parent_graphics) {
        if (!graphic) {
            return;
        }
        if (parent_graphics === undefined || parent_graphics === null) {
            return;
        }
        parent_graphics.addChild(graphic);
    }
    removeGraphics(ent, graphics) {
        let graphics_data = graphics.geometry.graphicsData;
        (0, lodash_1.remove)(graphics_data, (item) => item.entindex === ent);
        let any_ent = ent;
        if (any_ent._entity_graphics instanceof Array) {
            graphics.removeChild(...any_ent._entity_graphics);
        }
        if (any_ent._clip_graphics !== null) {
            graphics.removeChild(any_ent._clip_graphics);
        }
        graphics.geometry.invalidate();
        ent._graphicsData = [];
    }
    removeTrackGraphics(ent) {
        this.removeGraphics(ent, this._track_graphics);
    }
    clearTrackGraphics() {
        this._track_graphics.clear();
    }
    removeSelectGraphics(ent) {
        let graphics_data = this._select_graphics.geometry.graphicsData;
        (0, lodash_1.remove)(graphics_data, (item) => item.entindex === ent);
        let any_ent = ent;
        if (any_ent._select_graphics instanceof Array) {
            this._select_graphics.removeChild(...any_ent._select_graphics);
        }
        this._select_graphics.geometry.invalidate();
        any_ent._select_graphics = undefined;
    }
    //获取随机颜色;
    randomColor() {
        return `hsl(${Math.random() * 360}, 100%, 50%)`;
    }
    //转换为屏幕坐标;
    toScreenPoint(x, y) {
        let map_pos = new PIXI.Point();
        this._container.transform.worldTransform.apply({ x, y }, map_pos);
        return new ltpoint_1.LTPoint(map_pos.x, map_pos.y);
    }
    //转换为地图坐标;
    toMapPoint(x, y) {
        let map_pos = new PIXI.Point();
        this._container.transform.worldTransform.applyInverse({ x, y }, map_pos);
        return new ltpoint_1.LTPoint(map_pos.x, map_pos.y);
    }
    //全图显示;
    fullMap() {
        setTimeout(() => {
            let bounds = this._container.getLocalBounds();
            if (bounds.width == 0 || bounds.height == 0) {
                return;
            }
            this.zoomToRect(bounds);
        }, 10);
    }
    //缩放到范围;
    zoomToRect(bounds) {
        let scaleX = bounds.width / this.app.screen.width;
        let scaleY = (1.0 * bounds.height) / this.app.screen.height;
        let aspectFactor = scaleX / scaleY;
        let scale = 1.0;
        if (aspectFactor > 1.0) {
            //需要保证宽高比。
            let newHeight = this.app.screen.height * scaleX;
            let deltaHeightBuffer = (newHeight - bounds.height) / 2.0;
            bounds.y = bounds.y - deltaHeightBuffer;
            scale = scaleX;
        }
        else {
            let newWidth = this.app.screen.width * scaleY;
            let deltaWidthBuffer = (newWidth - bounds.width) / 2.0;
            bounds.x = bounds.x - deltaWidthBuffer;
            scale = scaleY;
        }
        //初始的默认矩阵;
        var mat = new PIXI.Matrix();
        mat.translate(0, -this.app.screen.height);
        mat.scale(1, -1);
        var new_mat = new PIXI.Matrix();
        new_mat.translate(-bounds.x, -bounds.y);
        new_mat.scale(1.0 / scale, 1.0 / scale);
        mat.append(new_mat);
        this._container.transform.setFromMatrix(mat);
    }
    //实现缩放功能;
    scaleMap(scale, center_x, center_y) {
        var container_mat = this._container.transform.worldTransform;
        var m1 = new PIXI.Matrix();
        m1.translate(center_x, center_y);
        var scale_mat = new PIXI.Matrix();
        scale_mat.scale(1 / scale, 1 / scale);
        var m2 = m1.append(scale_mat);
        var m3_mat = new PIXI.Matrix();
        m3_mat.translate(-center_x, -center_y);
        var m3 = m2.append(m3_mat);
        var m4 = container_mat.append(m3);
        this._container.transform.setFromMatrix(m4);
    }
    renderByLayer(layer, updateRbush) {
        var list = PIXI.Assets.get(resourceList);
        if (list[0] == undefined) {
            this.render(updateRbush, null);
            return;
        }
        if (this._canvas === null || layer.off === true) {
            return;
        }
        var features = layer.getFeatures(null);
        this.removeFeatureGraph(features);
        layer.layerGraphics.onlyAppend = true;
        for (let j = 0; j < features.length; j++) {
            var ent = features[j].getGeometry();
            if (ent != null) {
                //移除原来的
                ent._graphicsData = [];
                ent.worldDraw(this._canvas, true, null, layer.layerGraphics);
            }
        }
        if (updateRbush == true) {
            layer.updateRBush();
        }
        layer.layerGraphics.onlyAppend = false;
    }
    render(updateRbush = false, process_callback = null) {
        this.reset();
        //判断是否已经加载上
        var list = PIXI.Assets.get(resourceList);
        if (list[0] != undefined) {
            this._initCanvas();
            this._render(updateRbush, process_callback);
            //全图
            this.fullMap();
            return;
        }
        this._render(updateRbush, process_callback);
        //全图
        this.fullMap();
    }
    invalidate() {
        for (let layer of this._layers) {
            layer.layerGraphics.geometry.invalidate();
        }
    }
    _render(updateRbush, process_callback) {
        return __awaiter(this, void 0, void 0, function* () {
            //转到主线程；
            function yieldToMain() {
                // Fall back to setTimeout:
                return new Promise(resolve => {
                    setTimeout(resolve, 0);
                });
            }
            function setProcess(count, current_val, tip_text, is_close = false) {
                if (process_callback === null) {
                    return;
                }
                let message = {
                    text: tip_text,
                    count: count,
                    current: current_val,
                    close: is_close
                };
                process_callback(message);
            }
            const performStep = (map, layer, index) => __awaiter(this, void 0, void 0, function* () {
                var features = layer.getFeatures(null);
                map.canvas.calcBounds = true;
                layer.layerGraphics.onlyAppend = true;
                for (let j = 0; j < features.length; j++) {
                    var ent = features[j].getGeometry();
                    if (ent != null) {
                        ent._graphicsData = [];
                        ent.worldDraw(map.canvas, true, null, layer.layerGraphics);
                        if (j % 1000 == 0) {
                            yield yieldToMain();
                        }
                    }
                }
                if (updateRbush) {
                    layer.updateRBush(true);
                }
                yield yieldToMain();
                map.canvas.calcBounds = false;
                layer.layerGraphics.onlyAppend = false;
                if (index == map._layers.length) {
                    setProcess(map._layers.length, index, `完成加载:${layer.name}`, true);
                    map.invalidate();
                    map.fullMap();
                    //lsy 业务代码，将D-喷头图层放在其他图层上面，保证喷头显示在其他图层之上
                    let nozzle_layer = this.getLayerByName(sprinklerutils_1.SPRINKLER_NOZZLE_LAYER);
                    if (nozzle_layer !== null) {
                        nozzle_layer.layerGraphics.zIndex = 500;
                    }
                    this._container.sortChildren();
                }
                else {
                    setProcess(map._layers.length, index, `正在加载图层:${layer.name}`);
                }
            });
            if (this._canvas === null) {
                return;
            }
            for (let i = 0; i < this._layers.length; i++) {
                let layer = this._layers[i];
                yield performStep(this, layer, i + 1);
            }
        });
    }
    //重新绘制所有的对象;
    regen() {
        if (this._canvas === null) {
            return;
        }
        for (let layer of this._layers) {
            layer.layerGraphics.clear();
        }
        this.escape();
        this._canvas.init();
        this.render();
        this.fullMap();
    }
    selectedFeatures() {
        return this.select_command.selectedFeatures();
    }
    clearSelection() {
        return this.select_command.clearSelection();
    }
    selectFeatures(bounds, callback = null, temp_filter_layers = null) {
        var features = [];
        let filter_layers = this._layers;
        if (temp_filter_layers !== null) {
            filter_layers = temp_filter_layers;
        }
        for (let layer of filter_layers) {
            if (layer.off || layer.forzen) {
                continue;
            }
            let feas = layer.getFeatures(bounds, callback);
            features.push(...feas);
        }
        return features;
    }
    //点击单选要素对象;
    selectSingleFeature(map_pos, callback = null, temp_filter_layers = null) {
        var range_distance = 6 / this.mapScale();
        var bounds = ltpoint_1.RBox.fromCenter(map_pos, range_distance);
        var nest_distance;
        var nest_feature = null;
        var result_features = [];
        let filter_layers = this._layers;
        if (temp_filter_layers !== null) {
            filter_layers = temp_filter_layers;
        }
        for (let layer of filter_layers) {
            //不可选择不可见的对象;
            if (layer.off == true) {
                continue;
            }
            let fea = layer.getFeature(bounds, callback);
            if (fea != null) {
                result_features.push(fea);
            }
        }
        result_features.forEach(fea => {
            var dis = fea.getGeometry().data.getDistanceTo(map_pos, true);
            if (nest_distance == null || nest_distance > dis) {
                nest_distance = dis;
                nest_feature = fea;
            }
        });
        return nest_feature;
    }
    deleteFeatures(features) {
        for (let sub_feature of features) {
            let graphics = sub_feature.getGeometry();
            if (graphics != null) {
                sub_feature.state = ltfeature_1.CommitFlag.Delete;
                this.removeGraphics(sub_feature.getGeometry(), sub_feature.layer.layerGraphics);
            }
        }
    }
    addLayer(layer) {
        this._layers.push(layer);
    }
    getLayerByName(name) {
        for (let i = 0; i < this._layers.length; i++) {
            if (this._layers[i].name == name) {
                return this._layers[i];
            }
        }
        return null;
    }
    getLayers() {
        return this._layers;
    }
    setActiveLayer(layer) {
        this._active_layer = layer;
    }
    activeLayer() {
        if (this._active_layer == null) {
            for (let i = 0; i < this._layers.length; i++) {
                if (this._layers[i].off == false) {
                    this._active_layer = this._layers[i];
                }
            }
        }
        if (this._active_layer == null) {
            this._active_layer = this._layers[0];
        }
        return this._active_layer;
    }
    //打印命令的提示信息;
    printCommandTip(message) {
        if (window.showBlm !== undefined) {
            window.showBlm(message);
        }
        console.log(message);
    }
    printMessage(message) {
        if (!this._show_message) {
            return;
        }
        //命令提示的;
        if (this._command_graph == null) {
            this._command_graph = new PIXI.BitmapText("", {
                fontName: "正等线体", //字体名字就是我加载的fnt中的字体名,注意的是可能有文件名不相同
                fontSize: 16,
                align: "left",
                tint: "0xFFFFFF"
            });
            this._command_graph.position.x = 25;
            this._command_graph.position.y = this.app.screen.height - 60;
            this.app.stage.addChild(this._command_graph);
            this._command_alpha_filter = new PIXI.AlphaFilter(1);
            this._command_graph.filters = [this._command_alpha_filter];
            //为了保证一定有三条,不然显示的位置会很奇怪，先加两条空的;
            this._command_message.push("");
            this._command_message.push("");
        }
        this._command_message.push(message);
        while (this._command_message.length > 3) {
            this._command_message.shift();
        }
        this._command_alpha_filter.alpha = 1.0;
        let show_text = "";
        for (let i = 0; i < this._command_message.length; i++) {
            show_text += this._command_message[i] + "\n";
        }
        this._command_graph.text = show_text;
    }
    setMapID(map_id, url, temp_token, pId, process_callback) {
        return __awaiter(this, void 0, void 0, function* () {
            let dwg_service = new dwgservice_1.default({
                serviceUrl: url,
                mapid: map_id,
                //  serviceUrl: "http://localhost:8085/dwg/",
                //  mapid: "ba680d12",
                token: temp_token,
                productId: pId
            });
            console.log("mapid == " + map_id);
            if (dwg_service != null) {
                this._dwg_server.dwgService = dwg_service;
                yield dwg_service.initStyle(this, process_callback);
                dwg_service.getMaxID(this);
            }
        });
    }
    get dwgservice() {
        return this._dwg_server;
    }
    undoStack() {
        if (this._undo_stack == null) {
            this._undo_stack = new undostack_1.UndoStack(this);
        }
        return this._undo_stack;
    }
    addFeature(feature, isupdateRBush = true) {
        //添加一个翻译器;
        var add_command = new undostack_1.GeometryAddCommand(this, feature);
        for (const value of this._reators) {
            if (feature instanceof ltfeature_1.LTFeature) {
                if (!value.featureAppended(feature)) {
                    return;
                }
            }
            else {
                for (let i = 0; i < feature.length; ++i) {
                    if (!value.featureAppended(feature[i])) {
                        return;
                    }
                }
            }
        }
        this.undoStack().push(add_command);
    }
    addReactor(reactor) {
        this._reators.add(reactor);
    }
    removeReactor(rector) {
        this._reators.delete(rector);
    }
    changLayerVisible(layer, is_visible) {
        layer.off = !is_visible;
    }
    addFeatureGraph(feature) {
        if (this._canvas === null) {
            return;
        }
        var features = [];
        if (feature instanceof ltfeature_1.LTFeature) {
            features.push(feature);
        }
        else {
            features = feature;
        }
        for (let sub_feature of features) {
            var ent = sub_feature.getGeometry();
            if (ent != null) {
                this.removeGraphics(ent, sub_feature.layer.layerGraphics);
                ent._graphicsData = [];
                ent.worldDraw(this._canvas, true, null, sub_feature.layer.layerGraphics);
            }
        }
    }
    updateFeatureGeometry(feature, old_ent) {
        var update_command = new undostack_1.GeometryUpdateCommand2(this, feature, old_ent);
        for (const value of this._reators) {
            if (!value.featureModified(feature)) {
                return;
            }
        }
        this.undoStack().push(update_command);
        if (!this.undoStack().isInMacro()) {
            feature.layer.invalidate();
        }
    }
    updateFeature(feature, old_feature) {
        var update_command = new undostack_1.GeometryUpdateCommand(this, feature, old_feature);
        for (const value of this._reators) {
            if (!value.featureModified(feature)) {
                return;
            }
        }
        this.undoStack().push(update_command);
    }
    updateFeatureGraph(feature, old_ent) {
        let ent = feature.getGeometry();
        ent.worldDraw(this.canvas, true, null, feature.layer.layerGraphics);
        feature.layer.invalidate();
    }
    removeFeatures(features) {
        var delete_command = new undostack_1.GeometryDeleteCommand(this, features);
        this.undoStack().push(delete_command);
    }
    removeFeatureGraph(feature) {
        if (feature instanceof ltfeature_1.LTFeature) {
            this.removeGraphics(feature.getGeometry(), feature.layer.layerGraphics);
        }
        else {
            var features = feature;
            for (let sub_feature of features) {
                this.removeGraphics(sub_feature.getGeometry(), sub_feature.layer.layerGraphics);
            }
        }
    }
    getLayerInfo() {
        let infos = new ltvectorlayer_1.LayerInfos();
        for (let i = 0; i < this._layers.length; i++) {
            let info = this._layers[i].getLayerInfo();
            info.entities.forEach(entity => infos.setEntities(entity));
            info.lineWidth.forEach(entity => infos.setLineWidth(entity));
            info.linetypescales.forEach(entity => infos.setLinetypescale(entity));
        }
        return infos;
    }
}
exports.CadMap = CadMap;
